import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FtoReportResultRefresh } from '../report-result-refresh';
import { FtoReportComparativeLiteraturePublicityService, FtoReportTitleService, FtoReportNoveltyReviewService, FtoReportRetrievalResultReportSubtitleInfoService, FtoReportTechFeaturesService } from '../retrieval-result-report-service';
import { FtoReportComplexRetrievalService } from '../complex-retrieval-service';
import { FtoReportTaskStatusModel } from '../../models/task-status-model';
import { FtoTaskStep } from '../../enums';

@injectable()
export class FtoReportResultRefreshImpl implements FtoReportResultRefresh {
    // eslint-disable-next-line max-params
    constructor(
        @inject(FtoReportTitleService)
        private readonly _noveltyCheckReportTitleService: FtoReportTitleService,
        @inject(FtoReportRetrievalResultReportSubtitleInfoService)
        private readonly _retrievalResultReportSubtitleInfoService: FtoReportRetrievalResultReportSubtitleInfoService,
        @inject(FtoReportTechFeaturesService)
        private readonly _techFeaturesService: FtoReportTechFeaturesService,
        @inject(FtoReportComplexRetrievalService)
        private readonly _complexRetrievalService: FtoReportComplexRetrievalService,
        @inject(FtoReportComparativeLiteraturePublicityService)
        private readonly _comparativeLiteraturePublicityService: FtoReportComparativeLiteraturePublicityService,
        @inject(FtoReportNoveltyReviewService)
        private readonly _noveltyReviewService: FtoReportNoveltyReviewService,
        @inject(FtoReportTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: FtoReportTaskStatusModel,
    ) { }

    async refresh(): Promise<void> {
        if (this._noveltyCheckTaskStatusModel.modelData.taskStep !== FtoTaskStep.REPORT_CREATED) {
            // 获取搜索结果
            await this._complexRetrievalService.search();
            return;
        }

        Promise.all([
            // 获取新颖性报告名称
            this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取检索结果报告副标题信息
            this._retrievalResultReportSubtitleInfoService.pullRetrievalResultReportSubtitleInfo(),
            // 获取技术特征
            this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            this._complexRetrievalService.search(),
        ]);
    }
}
